import { useEffect, useState } from 'react'
import { getRadius } from 'src/Libs/chart-kit/pie-charts/utils/chart-calculations'
import { DEFAULT_PIE_CHART_HEIGHT } from 'src/Libs/system-charts/default-charts/pie-chart-constants'

export const PIE_CHARTS_BREAKPOINT = 900
const PIE_CHART_HEIGHT_BUFFER = 20
export const PIE_CHARTS_BREAKPOINT_XXS = 360

type UseChartDimensions = {
  chartSize: number
  innerRadius: number
  outerRadius: number
}

/*
 * This hook calculates the dimensions of the pie chart and the inner and outer radius
 */
export const useChartDimensions = ({
  height,
  width,
  legendHeight = 0,
  headerHeight = 0,
}: {
  height?: number
  width?: number
  legendHeight?: number
  headerHeight?: number
}): UseChartDimensions => {
  const [chartSize, setChartSize] = useState(DEFAULT_PIE_CHART_HEIGHT)

  useEffect(() => {
    if (height) {
      setChartSize(height + PIE_CHART_HEIGHT_BUFFER)
    }
  }, [height, legendHeight, width, headerHeight])

  const innerRadius = Math.min(getRadius(chartSize, chartSize).innerRadius, 125)
  const outerRadius = Math.min(getRadius(chartSize, chartSize).outerRadius, 150)

  return { chartSize, innerRadius, outerRadius }
}
